import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskPopupComponent } from './task-popup.component';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxPopupModule, DxTextAreaModule, DxValidatorModule, DxValidationSummaryModule, DxDateBoxModule, DxSliderModule, DxDataGridModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TaskPopupComponent],
  imports: [
    CommonModule,
    DevEpressCommonModule,
    DxPopupModule,
    DxTextAreaModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxDateBoxModule,
		DxSliderModule,
		FormsModule,
		ReactiveFormsModule,
    DxDataGridModule
  ],
  exports: [TaskPopupComponent]
})
export class TaskPopupModule { }
